import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=bdede308"
import script from "./Wechat.vue?vue&type=script&lang=ts"
export * from "./Wechat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "45785f60"
  
)

export default component.exports